import { AfterViewInit, Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";


/**
 * This is directive effect to mobile navbar when it has lots of items
 * Passing into the name of navbar
 * @using *autoScrollNavbar="'mixed-loyalty-nav'"
 */
@Directive({
    selector: '[autoScrollNavbar]'
})
export class autoScrollNavbar implements AfterViewInit {

    @Input('autoScrollNavbar') navbarClass: string = '';

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) { }

    ngAfterViewInit(): void {
        this.viewContainer.clear();
        this.viewContainer.createEmbeddedView(this.templateRef);
        setTimeout(() => {
            let navbar = document.getElementsByClassName(this.navbarClass)[0];
            navbar.classList.add('overflow-auto');
            let children = navbar.children;
            for (let i = 0; i < children.length; i++) {
                if (children[i].classList.contains('active')) {
                    navbar.scrollLeft =
                        (children[i] as HTMLDivElement).offsetLeft -
                        navbar.getBoundingClientRect().width / 2 +
                        (children[i] as HTMLDivElement).getBoundingClientRect().width / 2;
                }
            }
        });

    }


}
